import React from "react";
import { MenuActionCreators } from "../../../redux/action-creators";
import { useDispatch } from "react-redux";
import { SVGIcon2 } from "../../common/SVGIconV2";
import PropTypes from "prop-types";
import {
  ClosedSubMenuWrapper,
  CloseSubMenuBtn,
  CloseSubMenuTitle
} from "./ClosedSubMenuWrapper";

const InnerMenuHeader = props => {
  const { title } = props;
  const dispatch = useDispatch();

  const oncloseClick = () => {
    dispatch(MenuActionCreators.hideQuickLinksInnerMenu());
    dispatch(
      MenuActionCreators.setFavouriteSportsRunningInsideInnerMenu(false)
    );
  };

  return (
    <ClosedSubMenuWrapper>
      <CloseSubMenuTitle>{title}</CloseSubMenuTitle>
      <CloseSubMenuBtn onClick={oncloseClick}>
        <SVGIcon2 iconName="close" />
      </CloseSubMenuBtn>
    </ClosedSubMenuWrapper>
  );
};
InnerMenuHeader.propTypes = {
  title: PropTypes.string
};

export default React.memo(InnerMenuHeader);
